// extracted by mini-css-extract-plugin
export default {"description":"ConfirmPopup_description__J0fm3","wrapper":"ConfirmPopup_wrapper__lhySB","btn":"ConfirmPopup_btn__yJc01"};